import { localisedValue } from "utils";

const userAllocationTransformer = (response) => {
  if (!response || typeof response !== 'object' || !response.cities) {
    return []; 
  }
  const cities = [];
  for (let cityName in response.cities) {
    const city = response.cities[cityName];
    const teams = [];
    for (let teamName in city.teams) {
      const team = city.teams[teamName];
      const userIds = team?.users.map(item => item.userId).join(",");
      teams.push({
        name: teamName,
        count: team?.userCount,
        users: team?.users,
        userIds: userIds,
      });
    }
    cities.push({
      name: cityName,
      count: city?.totalUserCount || 0,
      teams: teams || [],
    });
  }

  return {
    totalUsers: response.totalUsers,
    numberOfCities: response.numberOfCities,
    numberOfTeams: response.numberOfTeams,
    cities: cities,
    projectId: response.projectId,
    name: localisedValue({ object: response, key: "projectName" }),
    projectImage: response.projectLogo,
  };
};

export default userAllocationTransformer;
